import * as React from 'react'
import './Definition.css'

import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap_white.css';
import './tooltip.css'

import * as _ from 'lodash'
import classNames from 'classnames'
// import { ObjectInspector } from 'react-inspector'


import Block from "./Block"
import Steps from "./Steps"
import Node from "./Node"
import NodeBox from "./NodeBox"
import NodeValue from "./NodeValue"
import EditableText from "./EditableText"
import WithContextMenu, { Menu } from "./WithContextMenu"


import { newId } from '../lib/id'
// import { evaluateSteps, runCodeToResult } from '../evaluate'
import { standardSCU, arrRemove } from '../util'
import { NetworkUser } from 'golgi'
import { Cursor, CursorV } from '../lib/Cursor'
import { Stack } from '../types/stack';

import * as actions from '../actions'
import * as Model from '../types/document'
import { runCodeToResult } from 'src/model/run';
import DefinitionInput from 'src/view/DefinitionInput';
import { definitionMenuMaker } from 'src/view/definitionMenuMaker';

class Definition extends React.Component<{
  definitionC: Cursor<Model.Definition>,
  stack: Stack,
}> {

  render() {
    return <NetworkUser debugName="Definition" props={this.props} state={this.state} render={() => {
      const {definitionC, stack} = this.props

      return (
        <Block
          className="Definition"
          attributes={{"data-definition": definitionC._('id').get()} as React.HTMLAttributes<HTMLDivElement>}
          left={<div className="Definition-heading">
            <WithContextMenu menuMaker = {definitionMenuMaker(definitionC)}>
              <div style={{height: 40, fontSize: "200%"}}>
                { definitionC._('isVisualization').get() &&
                  <span role='img' aria-label='visualization'>📊 </span>
                }
                <EditableText className="font-definition"
                  value={definitionC._('name').get()}
                  setValue={newValue => actions.act(() => {
                    if (definitionC._('name').get() !== newValue) {
                      definitionC.select('name').set(newValue)
                    }
                   })} />
              </div>
            </WithContextMenu>
            <div className="Definition-inputs">
              {CursorV.elemsKeyed(definitionC.select('inputs').fetch(), 'id').map((inputC, i) =>
                <DefinitionInput
                  key={inputC.lastStep().id}
                  inputC={inputC.unfetch()} definitionC={definitionC} stack={stack} />
              )}
              <button className="Definition-new-input" style={{width: 30, height: 30, flex: "0 0 auto"}}
                onClick={() => actions.act(() => {
                  definitionC.select('inputs').update((inputs) => {
                    const newInput = {
                      id: newId('node'),
                      name: "new input",
                      settings: [
                        ""
                      ],
                      activeSetting: 0,
                    }
                    return [...inputs, newInput]
                  })
                })}>
                +
              </button>
            </div>
          </div>}
          right={
            <Steps stepsC={definitionC.select('steps')} blockC={definitionC} stack={stack}/>
          }
        />
      )
    }} />
  }
}

export default Definition;



// WEBPACK FOOTER //
// ./src/view/Definition.tsx